export function formatFullDate(date: string | Date | null): string {
  if (!date) return '—'
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function truncateMid(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str
  const ext = str.lastIndexOf('.') !== -1 ? str.slice(str.lastIndexOf('.')) : ''
  const base = str.slice(0, str.length - ext.length)
  const keep = maxLength - ext.length - 3
  const start = Math.ceil(keep / 2)
  const end = Math.floor(keep / 2)
  return `${base.slice(0, start)}...${base.slice(-end)}${ext}`
}

export function formatDocLabel(
  fileName: string,
  type: string | null,
  label: string | null
): string {
  const suffix = [type ? `(${type})` : '', label ? `— ${label}` : ''].filter(Boolean).join(' ')
  const maxNameLen = suffix ? 25 : 40
  const name = truncateMid(fileName, maxNameLen)
  return suffix ? `${name} ${suffix}` : name
}

export function formatDateTime(date: string | Date | null): string {
  if (!date) return '—'
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
